<template>
  <div id="app">
    <router-view />
    <vue-snotify></vue-snotify>
  </div>
</template>

<script>
export default {
  components: {
  },
}
</script>

<style lang="stylus">
@import "~vue-snotify/styles/material.css";
@import url('https://fonts.googleapis.com/css?family=Lato:300,400,700');
*
  box-sizing border-box

body
  font-family 'Lato', Arial, sans-serif
  font-weight 300
  font-size 16px
  margin 0
  padding 0
  color #272727

body.home
  background-color #054350

input, textarea
  font-size 14px
  font-weight 300

h1
  font-size 32px

h2
  font-size 24px
  border-bottom 2px dotted #189ea6

h3
  font-size 20px

h4
  font-size 18px

a
  color #189ea6

button, a.button
  cursor pointer
  background #f2cf63
  border-radius 3px
  border 0
  color #272727
  padding 7px 15px
  font-size 12px
  text-transform uppercase
  font-weight 700
  text-decoration none
  display inline-block
  margin-bottom 10px

button:hover:not([disabled]), a.button:hover:not([disabled])
  background #eba227

button:disabled
  opacity .33
  cursor auto

button:focus
  outline none

.buttoncontainer
  display flex
  text-align center


.buttoncontainer div
  margin 0 10px 10px 0


input
  padding 7px
  border 1px solid #ccc

textarea
  border 1px solid #ccc

.owl
  &> * + *
    margin-left 1em

.v-owl
  &> * + *
    margin-top 1em

.disabled
  opacity 0.5
  pointer-events none

label
  font-weight bold
  cursor pointer

</style>
